import { render } from "./SVGIcon.vue?vue&type=template&id=7f6cc5c3&scoped=true"
import script from "./SVGIcon.vue?vue&type=script&lang=js"
export * from "./SVGIcon.vue?vue&type=script&lang=js"

import "./SVGIcon.vue?vue&type=style&index=0&id=7f6cc5c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6cc5c3"]])

export default __exports__